import { useContext } from 'react';
import { giftcardState } from '../client-state/giftcard-state-context';
import PaymentSuccess from '../../../ui-components/payment-success';
import { getLocalizedShopSettings } from '../../../Utils/locale';
import useLocale from '../../../Hooks/use-locale';
import useLocalize from '../../../Hooks/useLocalize';
import useGiftcardShop from '../server-data/use-giftcard-shop';

const PaymentSuccessWithData = () => {
  const { data: shop } = useGiftcardShop();
  const { state } = useContext(giftcardState);
  const { languageAsEnum } = useLocale();
  const localize = useLocalize();

  return (
    <PaymentSuccess
      heading={
        shop?.bookingLocalizations?.paymentSuccessHeading?.[languageAsEnum] ||
        `${localize('product.thankYou')} ${localize('product.captain')}`
      }
      text={
        shop?.shopSettings?.giftcard?.paymentSuccessText
          ? getLocalizedShopSettings(
              shop?.shopSettings.giftcard.paymentSuccessText,
              languageAsEnum
            )
          : localize('giftcard.defaultPaymentSuccessText')
      }
      link={
        shop?.shopSettings?.giftcard?.paymentSuccessLink
          ? getLocalizedShopSettings(
              shop?.shopSettings.giftcard.paymentSuccessLink,
              languageAsEnum
            )
          : shop?.website
          ? `https://${shop?.website}`
          : languageAsEnum === 'en'
          ? 'https://goboat.dk/en'
          : 'https://goboat.dk'
      }
      showEmail={shop?.shopSettings?.giftcard?.paymentSuccessShowEmail ?? true}
      customer={state.customer.customer}
    />
  );
};

export default PaymentSuccessWithData;
